import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { ExemplarHeaderWrapper, ExemplarWrapper, FlexWrapper } from '../../../components/Styled';

import { COLORS } from '../../../constants';
import { getCollectionIcon } from '../../../utils';
import { BookLabelName } from '../../../types/exemplars';
import { StyledExplanation, StyledAccessCode } from '../../../components/Styled/StyledExemplarStageAccessCode';
import { StyledLink } from '../../../components/Styled/StyledDropDownMenu';

interface IExemplarStageAccessCode extends RouteComponentProps {
  level?: string;
  stage?: string;
}
export const ExemplarStageAccessCode = (props: IExemplarStageAccessCode): JSX.Element => {
  const { level, stage } = props;

  return (
    <>
      <ExemplarWrapper margin="40px auto 41px">
        <ExemplarHeaderWrapper letterColor={COLORS[level as string]} backgroundColor={COLORS[`${level}BG`]}>
          <FlexWrapper>
            <span style={{ padding: '0 12px 0px 0px' }}>{stage}</span>
            {getCollectionIcon(`${stage} ${level}` as BookLabelName)}
          </FlexWrapper>
        </ExemplarHeaderWrapper>
        <StyledExplanation>
          If you have purchased the {stage} {level} Big Book, please enter your access code to view the digital content.
        </StyledExplanation>
        <StyledLink to="/accesscode">
          <StyledAccessCode>ENTER ACCESS CODE</StyledAccessCode>
        </StyledLink>
      </ExemplarWrapper>
    </>
  );
};
